export const error_msg = {
  /* ----- DRIVER SECTION ------ */
  // First name field
  FIRST_NAME_REQUIRED: "First name required",
  FIRST_NAME_MIN_LENGTH: minLength => `First name should have minimum ${minLength} characters`,
  FIRST_NAME_MAX_LENGTH: maxLength => `First name can't exceed ${maxLength} characters`,
  FIRST_NAME_ONLY_CHARS: "First name can only have alphabets",

  // Last name field
  LAST_NAME_REQUIRED: "Last name required",
  LAST_NAME_MIN_LENGTH: minLength => `Last name should have minimum ${minLength} characters`,
  LAST_NAME_MAX_LENGHT: maxLength => `Last name can't exceed ${maxLength} characters`,
  LAST_NAME_ONLY_CHARS: "Last name can only have alphabets",

  // cell number
  CELL_NUMBER_REQUIRED: "Mobile number required",
  CELL_NUMBER_MIN_LENGTH: minLength => `Mobile number should have minimum ${minLength} numbers`,
  CELL_NUMBER_MAX_LENGTH: maxLength => `Mobile number can't exceed ${maxLength} numbers`,
  CELL_NUMBER_PATTERN: "Mobile number can only have numbers",

  // Email field
  EMAIL_REQUIRED: "Email-id required",
  EMAIL_INCORRECT_FORMAT: "Email is not in correct format (abc@xyz.com)",
  EMAIL_MAX_LENGTH: maxLength => `Email can't exceed ${maxLength} characters`,

  // NRIC Number
  NRIC_NUMBER_REQUIRED: "NRIC number required",
  NRIC_NUMBER_MIN_LENGTH: minLength => `NRIC number should have minimum ${minLength} numbers`,
  NRIC_NUMBER_MAX_LENGTH: maxLength => `NRIC number can't exceed ${maxLength} numbers`,
  NRIC_NUMBER_PATTERN: "NRIC number can only have numbers",

  // stripe_account_id
  STRIPE_ACCOUNT_ID_REQUIRED: "STRIPE ACCOUNT ID required",
  STRIPE_ACCOUNT_ID_MIN_LENGTH: minLength => `STRIPE ACCOUNT ID should have minimum ${minLength} numbers`,
  STRIPE_ACCOUNT_ID_MAX_LENGTH: maxLength => `STRIPE ACCOUNT ID can't exceed ${maxLength} numbers`,
  STRIPE_ACCOUNT_ID_PATTERN: "STRIPE ACCOUNT ID can only have numbers",
  // No. of passengers
  NO_OF_PASSENGERS_REQUIRED: "No. of passengers required",
  NO_OF_PASSENGERS_PATTERN: "No. of passengers can only have numbers",
  NO_OF_PASSENGERS_MIN_NUMBER: min => `Minimum no. of passengers cannot be less than ${min}`,
  NO_OF_PASSENGERS_MAX_NUMBER: max => `Maximum no. of passengers can't exceed ${max}`,

  // vehicle make
  VEHICLE_MAKE_REQUIRED: "Vehicle Make required",

  // vehicle model
  VEHICLE_MODEL_REQUIRED: "Vehicle Model required",

  // vehicle year
  VEHICLE_YEAR_REQUIRED: "Vehicle year required",
  VEHICLE_YEAR_PATTERN: "Vehicle year can only have numbers",

  // vehicle mileage
  PH_DECAL_NUMBER_REQUIRED: "Ph decal number required",
  PH_DECAL_NUMBER_PATTERN: "Ph decal number can only have numbers",
  PH_DECAL_NUMBER_MAX_LENGTH: maxLength => `Ph decal number can't exceed ${maxLength} numbers`,

  // Vehicle plate Number
  VEHICLE_PLATE_NUMBER_REQUIRED: "Vehicle plate number required",
  VEHICLE_PLATE_NUMBER_MIN_LENGTH: minLength => `Vehicle plate number should have minimum ${minLength} numbers`,
  VEHICLE_PLATE_NUMBER_MAX_LENGTH: maxLength => `Vehicle plate number can't exceed ${maxLength} numbers`,

  // Vehicle category
  VEHICLE_CATEGORY_REQUIRED: "Vehicle category required",

  // Referral code
  REFERRAL_CODE_MIN_LENGTH: minLength => `Referral code should have minimum ${minLength} numbers`,
  REFERRAL_CODE_MAX_LENGTH: maxLength => `Referral code can't exceed ${maxLength} numbers`,

  // Profile image
  PROFILE_IMAGE_REQUIRED: "Profile image required",

  // Insurance image
  INSURANCE_IMAGE_REQUIRED: "Insurance image required",

  // License front image
  LICENSE_FRONT_IMAGE_REQUIRED: "License front image required",

  // License back image
  LICENSE_BACK_IMAGE_REQUIRED: "License back image required",

  // nric front image
  NRIC_FRONT_IMAGE_REQUIRED: "NRIC front image required",

  // nric back image
  NRIC_BACK_IMAGE_REQUIRED: "NRIC back image required",

  // rental agreement image
  RENTAL_AGREEMENT_FRONT_IMAGE_REQUIRED: "Rental agreement front image required",
  RENTAL_AGREEMENT_BACK_IMAGE_REQUIRED: "Rental agreement back image required",

  // vocational license image
  VOCATIONAL_LICENSE_IMAGE_REQUIRED: "Vocational license image required",

  // vehicle registration image
  VEHICLE_REGISTRATION_IMAGE_REQUIRED: "Vehicle registration image required",

  /* ------------------------ RIDER SECTION ------------------ */

  /* ------------------------ PROMO CODE SECTION --------------- */
  PROMO_TYPE_REQUIRED: "Please select promo type",
  PROMO_TITLE_REQUIRED: "Promo title required",
  DISCOUNT_TYPE_REQUIRED: "Discount type required",
  MAXIMUM_DISCOUNT_REQUIRED: "Maximum discount required",
  MAXIMUM_DISCOUNT_PATTERN: "Maximum discount can only have numbers",
  MAXIMUM_DISCOUNT_MIN_NUMBER: min => `Maximum discount can't be less than ${min}`,
  MAXIMUM_DISCOUNT_MAX_NUMBER: max => `Maximum discount can't exceed ${max}`,
  PERCENT_DISCOUNT_REQUIRED: "Percent discount required",
  PERCENT_DISCOUNT_PATTERN: "Percent discount can only have numbers",
  PERCENT_DISCOUNT_MIN_NUMBER: min => `Percent discount can't be less than ${min}`,
  PERCENT_DISCOUNT_MAX_NUMBER: max => `Percent discount can't exceed ${max}`,
  LIMIT_PER_USER_REQUIRED: "Limit per user reuired",
  LIMIT_PER_USER_PATTERN: "Limit per user can only have numbers",
  LIMIT_PER_USER_MIN_NUMBER: min => `Limit per user can't be less than ${min}`,
  LIMIT_PER_USER_MAX_NUMBER: max => `Limit per user can't exceed ${max}`,
  USAGE_LIMIT_REQUIRED: "Usage limit required",
  START_DATE_REQUIRED: "Start date required",
  END_DATE_REQUIRED: "End date required",
  INTERVAL_REQUIRED: "Interval required",
  COUPON_CODE_REQUIRED: "Coupon code required",
  TERMS_AND_CONDITION_REQUIRED: "Terms and conditions required",

  /*------------------------------- SETTING SECTION ----------------------- */
  TAXI_IMAGE_REQUIRED: "Taxi image required",
  CATEGORY_NAME_REQUIRED: "Category name required",
  CAPACITY_REQUIRED: "Capacity required",

  MAKE_NAME_REQUIRED: "Make name required",

  MAKE_REQUIRED: "Make required",
  MODEL_REQUIRED: "Model required",
  CATEGORY_REQUIRED: "Category required",

  // -----commission Setting-------//

  SIX_PERCENTAGE_REQUIRED: "TAXIWHEELpercentage required",
  SIX_PERCENTAGE_MAX: max => `TAXIWHEELpercentage can't exceed ${max} number`,

  DRIVER_PERCENTAGE_REQUIRED: "driverpercentage required",
  DRIVER_PERCENTAGE_MAX: max => `driver percentage can't exceed ${max} number`,

  REFERRER_COMMISSION_REQUIRED: "referrer commission required",
  REFERRER_COMMISSION_MAX: max => `referrer commission can't exceed ${max} number`,

  ADMIN_FEE_REQUIRED: "admin fee required",
  ADMIN_FEE_MAX: max => `admin fee can't exceed ${max} number`,

  REFERRAL_BONUS_REQUIRED: "referral bonus required",
  REFERRAL_BONUS_MAX: max => `referral bonus can't exceed ${max} number`,

  MINIMUM_PAYOUT_REQUIRED: "minimum payout required",
  MINIMUM_PAYOUT_MAX: max => `minimum payout can't exceed ${max} number`,

  PAYOUT_CYCLE_REQUIRED: "payout cycle required",
  PAYOUT_CYCLE_MAX: max => `payout cycle can't exceed ${max} number`,

  PAYOUT_DAY_REQUIRED: "payout day required",
  PAYOUT_DAY_MAX: max => `payout day can't exceed ${max} number`,
  // -----Fare Setting-------//
  BASE_FARE_REQUIRED: "base fare required",
  BASE_FARE_MAX: max => `base fare can't exceed ${max} number`,

  CATEGORY_NAME_F_REQUIRED: "category name required",
  CATEGORY_NAME_F_MAX: max => `category name can't exceed ${max} number`,

  PER_KM_FARE_REQUIRED: "per km fare required",
  PER_KM_FARE_MAX: max => `per km fare can't exceed ${max} number`,

  MINIMUM_FARE_REQUIRED: "minimum fare required",
  MINIMUM_FARE_MAX: max => `minimum fare can't exceed ${max} number`,

  MINIMUM_FARE_KM_REQUIRED: "minimum fare KM required",
  MINIMUM_FARE_KM_MAX: max => `minimum fare KM can't exceed ${max} number`,

  PING_RADIUS_REQUIRED: "Ping Radius required",
  PING_RADIUS_MAX: max => `Ping Radius can't exceed ${max} number`,

  CAPTURE_FARE_REQUIRED: "Capture Fare required",
  CAPTURE_FARE_MAX: max => `Capture Fare can't exceed ${max} number`,

  /* ------------------------ EMAIL TEMPLATE -------------- */
  TYPE_REQUIRED: "Template type required",
  SUBJECT_REQUIRED: "Subject required",
  DESCRIPTION_REQUIRED: "Description required",

  /* ------------------------ FILTER  ------------------ */
  NAME_REQUIRED: "Name required",
  NAME: minLength => `Name should have minimum ${minLength} characters`,
  NAME_MAX_LENGTH: maxLength => `Name can't exceed ${maxLength} characters`,
  NAME_ONLY_CHARS: "Name can only have alphabets",

  DATE_COMPARER: "From date cannot be lesser than to date",

  // Reset Password form
  CURRENT_PASSWORD_REQUIRED: "Current password required",
  NEW_PASSWORD_REQUIRED: "New password required",
  CONFIRM_PASSWORD_REQUIRED: "Confirm  password required",
  PASSWORD_MAX_LENGTH: maxLength => `Password can't exceed ${maxLength} characters`,
  PASSWORD_MIN_LENGTH: minLength => `Password should have minimum ${minLength} characters`,

  SESSION_TIMOUT_MESSAGE: "Your session has been timed out",

  // Start: Message to driver
  SELECT_DRIVERS: "Select drivers to send message or select 'All Drivers'",
  DRIVER_STATUS_NOT_SELECTED: "Select status of drivers",
  CUSTOMER_STATUS_NOT_SELECTED: "Select status of customers",
  ENTER_MESSAGE: "Enter message",
  SELECT_CUSTOMERS: "Select customers to send message or select 'All Drivers'",

  // End: Message to driver

  TEXT_TEMPLATE_NAME_REQUIRED: "Text Template required",
  SEQUENCE_NUMBER_NAME_REQUIRED: "Sequence Number required"
};

/**
 *
 * Below are notification constanst
 * ********************************
 */

export const notification_msg = {
  // Start : driver Section//
  DRIVER_ADD_SUCCESS: "Driver details added successfully",
  DRIVER_UPDATE_SUCCESS: "Driver details updated successfully",
  // End : driver Section//

  // Start : rider section //
  RIDER_UPDATE_SUCCESS: "Rider details updated successfully",
  // End : rider Section

  //Start : promo code section
  FIRST_TIME_RIDE_ADD_SUCCESS: "First time ride promo code added successfully",
  FIRST_TIME_RIDE_UPDATE_SUCCESS: "First time ride promo code updated successfully",
  HAPPY_HOUR_DISCOUNT_ADD_SUCCESS: "Happy hour discount promo code added successfully",
  HAPPY_HOUR_DISCOUNT_UPDATE_SUCCESS: "Happy hour discount promo code updated successfully",
  HAPPY_DAY_DISCOUNT_ADD_SUCCESS: "Happy day discount promo code added successfully",
  HAPPY_DAY_DISCOUNT_UPDATE_SUCCESS: "Happy day discount promo code updated successfully",
  // End: promo code section

  // Start: setting section
  CATEGORY_ADD_SUCCESS: "Category added successfully",
  CATEGORY_UPDATE_SUCCESS: "Category updated successfully",

  MODEL_ADD_SUCCESS: "Model added successfully",
  MODEL_UPDATE_SUCCESS: "Model updated successfully",

  MAKE_ADD_SUCCESS: "Make added successfully",
  MAKE_UPDATE_SUCCESS: "Make updated successfully",

  SETTING_UPDATE_SUCCESS: "settings updated successfully",
  SETTING_UPDATE_ALERT: "Are you sure want to update setting ?",

  FARE_SETTING_UPDATE_SUCCESS: "Fare settings updated successfully",
  FARE_SETTING_UPDATE_ALERT: "Are you sure want to update setting ?",

  //End: setting section

  // Start: change password
  PASSWORD_UPDATE_SUCCESS: "Password changed successfully",
  //EndL change password

  TEMPLATE_UPDATE_SUCCESS: "Email template updated successfully",

  SERVER_NOT_RESPONDING: "Server not responding",

  FILL_ALL_DETAILS: "Please fill all the necessary details",
  UNAUTHORIZED_ACCESS: "Unauthorized Access",

  MASS_EMAIL_SENT_SUCCUSS: "Email sent successfully",
  MASS_EMAIL_NOT_SENT_SUCCUSS: "Email not sent successfully",

  MASS_NOTIFICATION_SENT_SUCCUSS: "Notification sent successfully",

  // Template

  TEXT_TEMPLATE_ADD_SUCCESS: "Text Template added successfully",
  TEXT_TEMPLATE_UPDATE_SUCCESS: "Text Template updated successfully"
};

export const element_ids = {
  NAVBAR_ID: "navbarSupportedContent"
};

export const default_const = {
  NO_USER_IMAGE: "",
  SESSION_TIMOUT_DURATION: 600,
  ARRAY_LIMIT: 5,
  ROW_LIMIT: 5,
  PHONE_NUMBER_COUNTRY: "SG",
  PHONE_NUMBER_COUNTRY_CODE: "+65",

  MONTH_LIST: () => {
    let array = [
      {
        name: "January",
        short: "Jan",
        number: 1,
        days: 31
      },
      {
        name: "February",
        short: "Feb",
        number: 2,
        days: 28
      },
      {
        name: "March",
        short: "Mar",
        number: 3,
        days: 31
      },
      {
        name: "April",
        short: "Apr",
        number: 4,
        days: 30
      },
      {
        name: "May",
        short: "May",
        number: 5,
        days: 31
      },
      {
        name: "June",
        short: "Jun",
        number: 6,
        days: 30
      },
      {
        name: "July",
        short: "Jul",
        number: 7,
        days: 31
      },
      {
        name: "August",
        short: "Aug",
        number: 8,
        days: 31
      },
      {
        name: "September",
        short: "Sep",
        number: 9,
        days: 30
      },
      {
        name: "October",
        short: "Oct",
        number: 10,
        days: 31
      },
      {
        name: "November",
        short: "Nov",
        number: 11,
        days: 30
      },
      {
        name: "December",
        short: "Dec",
        number: 12,
        days: 31
      }
    ];
    return array;
  },

  YEAR_LIST: (START, END) => {
    let array = [];
    for (let index = START; index < END; index++) {
      array.push({ key: index, value: index });
    }
    return array;
  }
};



// WEBPACK FOOTER //
// ./src/app/shared/constants/consts.ts